import { combineReducers } from 'redux'

import authenticate from './authenticate'
import login from './login'
import register from './register'
import changePassword from './changePassword'
import referralCode from './referralCode'

export default combineReducers({
  authenticate: authenticate,
  login: login,
  register: register,
  changePassword: changePassword,
  referralCode: referralCode
})
